import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Page = styled.a`
  width: 30px;
  height: 30px;
  border: solid 1px #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  text-decoration: none;
  color: inherit;

  &.disable {
    cursor: default;
    background: #fff;
    pointer-events: none;
    border: none;
  }

  &.active {
    cursor: default;
    background: #f0f0f0;
    pointer-events: none;
  }

  &:hover:not(.disable) {
    background: #efefef;
  }
`;

class Pagination extends React.Component {
  render() {
    const page = this.props.page;
    const pages = Math.floor(this.props.count / this.props.items) + 1;

    return (
      <Container>
        {page > 2 && <Page href={`${this.props.changeUrl}${1}`}>1</Page>}

        {page > 3 && (
          <Page href={"#"} className={"disable"}>
            ...
          </Page>
        )}

        {page - 1 > 0 && (
          <Page href={`${this.props.changeUrl}${page - 1}`}>
            <>{page - 1}</>
          </Page>
        )}

        <Page className={"active"} href={`${this.props.changeUrl}${page}`}>
          <>{page}</>
        </Page>

        {page + 1 <= pages - 1 && (
          <Page href={`${this.props.changeUrl}${page + 1}`}>
            <>{page + 1}</>
          </Page>
        )}

        {page < pages - 1 && (
          <Page href={"#"} disable className={"disable"}>
            ...
          </Page>
        )}

        {page !== pages && <Page href={`${this.props.changeUrl}${pages}`}>{pages}</Page>}
      </Container>
    );
  }
}

export default Pagination;
